import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { InputField } from '../../model';
import { HeaderEditorStoreService } from '../header-editor/header-editor-store.service';
import { FieldUpdaterService } from './field-updater.service';

@Component({
  selector: 'kve-field-editor',
  templateUrl: './field-editor.component.html',
  styleUrls: ['./field-editor.component.scss']
})
export class FieldEditorComponent implements OnInit {
  @Input() field:InputField;

  @Output() updateField:EventEmitter<any> = new EventEmitter<any>();

  readonly:boolean = false;
  popOver:boolean = false;

  /* {
    name:"width",
    title:"Width",
    type:'number',
    controlType:'drop-down'
  },
  {
    name:"background",
    type:"string",
    controlType:'color-picker'
  },
  {
    name:"seo",
    title:"SEO",
    type:"group",
    controlType:'dialog'
  },
  {
    name:'padding',
    title:'Padding',
    type:'group',
    controlType:'slider'
  },
  {
    name:"margin",
    title:"Margin",
    type:"group",
    controlType:"slider"
  },
  {
    name:'border',
    title:"Border",
    type:"group",
    controlType:"slider"
  } */
  
  constructor(private updaterService:FieldUpdaterService) { }

  ngOnInit(): void {
    this.readonly = this.field.readonly !== undefined ? this.field.readonly : false;
    if(this.field.context && this.field.context.popOver !== undefined){
      this.popOver = this.field.context.popOver
    }
    
  }

  onFieldUpdate(field:InputField){
    console.log(field);
    this.updateField.emit(field);
    if(field.context != null && field.context != undefined){
      let context = field.context;
      let section = context["section"]?context["section"]:null;
      let key = context["key"]?context["key"]:null;
      if(section != null && key != null){
        this.updaterService.updateField(section,key,field);
       // this.delegateFieldUpdate(section,key,field);
      }
    }
  }

  onSubmitInput(value:any){
    console.log(value)
    this.updateField.emit(value);
  }

}
